import { render, staticRenderFns } from "./EnrolledStudentsReport.vue?vue&type=template&id=1be50516&scoped=true&"
import script from "./EnrolledStudentsReport.vue?vue&type=script&lang=js&"
export * from "./EnrolledStudentsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be50516",
  null
  
)

export default component.exports